import React from 'react';
import Helmet from 'react-helmet';
export default function Page({ title, children }) {
    return (React.createElement(React.Fragment, null,
        title && (React.createElement(Helmet, null,
            React.createElement("title", null, title))),
        children));
}
